import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";

export interface PaywallRouterContext {
  paywallId: number;
}

export const rootRoute = createRootRouteWithContext<PaywallRouterContext>()({
  component: Outlet,
});
